module.exports = __webpack_public_path__ + "img/taken.a249e489.svg";